<template>
  <div class="header flex-row">
    <img src="../assets/images/model-com/icon.png" class="icon" alt="" />
    <p class="left">{{ left }}</p>
    <!-- <div class="flex-row" v-if="right" @click="handleClick">
      <p>{{ right }}</p>
      <van-icon name="arrow" />
    </div> -->
  </div>
</template>
<script>
export default {
  name: "CustomInput",
  props: {
    left: {
      type: String,
      default: "",
    },
    right: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleClick() {
      this.$emit("custom-click"); // 触发自定义事件
    },
  },
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  align-items: center;
  padding: 10px 0;
  box-sizing: border-box;
  margin-left: 20px;

  .left {
    font-weight: 600;
    font-size: 14px;
    color: #1d1d1d;
    line-height: 22px;
    display: flex;
    align-items: center;
    margin-left: 5px;
  }
  // .left::before {
  //   content: "";
  //   width: 4px;
  //   border-radius: 30px;
  //   display: block;
  //   margin-right: 8px;
  //   height: 15px;
  //   background: linear-gradient(134deg, #00e29f 0%, #00d1e1 100%);
  // }
  div {
    font-weight: 600;
    font-size: 13px;
    color: #0065ff;
    line-height: 20px;
    align-items: center;
  }
}
.icon {
  width: 20px;
  height: 20px;
}
</style>
